<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <validation-provider
          #default="{ errors }"
          name="Key Server"
          rules="required"
        >
          <input-field
            name="wide_wine-keyServer"
            label="Key Server *"
            label-position="top"
            :error="errors.length ? errors[0] : null"
          >
            <b-form-input
              id="wide_wine-keyServer"
              v-model="settings.keyServerUrl"
              placeholder="Enter key server url here..."
              :state="errors.length > 0 ? false : null"
            />
          </input-field>
        </validation-provider>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <validation-provider
          #default="{ errors }"
          name="Signer"
          rules="required"
        >
          <input-field
            name="wide_wine-signer"
            label="Signer *"
            label-position="top"
            :error="errors.length ? errors[0] : null"
          >
            <b-form-input
              id="wide_wine-signer"
              v-model="settings.signer"
              placeholder="Enter signer here..."
              :state="errors.length > 0 ? false : null"
            />
          </input-field>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <validation-provider
          #default="{ errors }"
          name="AES Signing Key"
          :rules="
            !settings.rsaSigningKeyPath || settings.aesSigningIV
              ? 'required'
              : ''
          "
        >
          <input-field
            name="wide_wine-aesSigningKey"
            label="AES Signing Key"
            label-position="top"
            :error="errors.length ? errors[0] : null"
          >
            <b-form-input
              id="wide_wine-aesSigningKey"
              v-model="settings.aesSigningKey"
              placeholder="Enter aes signing key..."
              :state="errors.length > 0 ? false : null"
            />
          </input-field>
        </validation-provider>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <validation-provider
          #default="{ errors }"
          name="AES Signing IV"
          :rules="
            !settings.rsaSigningKeyPath || settings.aesSigningKey
              ? 'required'
              : ''
          "
        >
          <input-field
            name="wide_wine-aesSigningIV"
            :error="errors.length ? errors[0] : null"
            label="AES Signing IV"
            label-position="top"
          >
            <b-form-input
              id="wide_wine-aesSigningIV"
              v-model="settings.aesSigningIV"
              :state="errors.length > 0 ? false : null"
              placeholder="Enter AES signing IV..."
            />
          </input-field>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <validation-provider
          #default="{ errors }"
          name="RSA signing key path"
          :rules="
            !settings.aesSigningKey && !settings.aesSigningIV ? 'required' : ''
          "
        >
          <input-field
            name="wide_wine-rsaSigningKeyPath"
            label="RSA Signing Key Path"
            :error="errors.length ? errors[0] : null"
            label-position="top"
          >
            <b-form-input
              id="wide_wine-aesSigningKey"
              v-model="settings.rsaSigningKeyPath"
              :state="errors.length > 0 ? false : null"
              placeholder="Enter RSA signing key path..."
            />
          </input-field>
        </validation-provider>
      </b-col>
      <b-col />
    </b-row>
    <b-row>
      <b-col>
        <custom-alert icon-name="Info">
          <strong>Important:</strong>
          You have to at least give AES Signing Key or RSA Signing Key Path in
          order to use Wide Vine Encryption.
        </custom-alert>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import InputField from '@/components/form/InputField.vue'
import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'

export default {
  name: 'WideVine',
  components: {
    ValidationProvider,
    InputField,
  },
  props: {
    settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
}
</script>
